export const mockIncomes = [
  {
    id: '1',
    title: 'Mağaza Raf Kiralama',
    amount: 2500,
    date: '2026-06-01',
    payment_type: 'Nakit',
    description: 'Komşu butiğin raf kiralama geliri',
    created_at: '2026-06-01T10:00:00Z',
  },
  {
    id: '2',
    title: 'Eski Sezon İndirim Satışı',
    amount: 3500,
    date: '2026-05-28',
    payment_type: 'Kart',
    description: 'Eski sezon ürünlerin indirimli satışı',
    created_at: '2026-05-28T14:00:00Z',
  },
  {
    id: '3',
    title: 'Online Satış Komisyonu',
    amount: 1800,
    date: '2026-05-25',
    payment_type: 'Havale',
    description: 'Trendyol komisyon geliri',
    created_at: '2026-05-25T11:00:00Z',
  },
  {
    id: '4',
    title: 'Mağaza Raf Kiralama',
    amount: 2500,
    date: '2026-05-01',
    payment_type: 'Nakit',
    description: 'Mayıs ayı raf kiralama geliri',
    created_at: '2026-05-01T09:00:00Z',
  },
  {
    id: '5',
    title: 'Toptan Satış',
    amount: 12000,
    date: '2026-05-15',
    payment_type: 'Havale',
    description: 'Başka bir butiğe toptan satış',
    created_at: '2026-05-15T13:00:00Z',
  },
  {
    id: '6',
    title: 'Eski Sezon İndirim',
    amount: 4200,
    date: '2026-05-10',
    payment_type: 'Kart',
    description: 'Nisan indirim kampanyası satışları',
    created_at: '2026-05-10T10:00:00Z',
  },
];